<template>
    <div>
        <div class="elevation-1">
            <HeaderForm title="Vincular Produto" icon="mdi-domain" :id="`${company.id}`" :name="company.name"
                :onClickBackButton="goToBackList" />
            <v-container fluid>
                <v-row>
                    <v-col cols="12" xs="12" md="6">
                        <v-autocomplete :disabled="isUpdating" :loading="isLoading" :items="hideProductsExist(products)"
                            v-model="productSelected" outlined dense no-data-text="Nenhum Produto para vincular"
                            :error-messages="errorMessageCompanyAutocomplete" color="blue-grey lighten-2"
                            label="Selecione um Produto" item-text="product_name" item-value="id">
                            <template v-slot:item="data">
                                <template>
                                    <v-list-item-avatar>
                                        {{ data.item.id }}
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-html="data.item.product_name"></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" xs="12" md="2">
                        <v-btn color="success" @click="handleAddProduct">
                            <v-icon left>mdi-plus</v-icon>
                            Adicionar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col>
                        <simple-table title="Produtos Vinculadas" :headers="headers" :items="company.products"
                            :sortBy="['product_name']">
                            <template v-slot:actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon medium @click="deleteProduct(item)" color="red" v-bind="attrs"
                                            v-on="on">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <span>Desvincular</span>
                                </v-tooltip>
                            </template>
                        </simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <DialogDelete message="Deseja realmente desvincular esse produto?" :dialog="dialogDelete"
            textBntConfirm="Desvincular" :confirmDialog="handleConfirmDelete" :cancelDialog="handleCancelDelete" />
    </div>
</template>
<script>
import HeaderForm from "@/components/HeaderForm";
import SimpleTable from "@/components/SimpleTable";
import DialogDelete from "@/components/DialogDelete";
import { mapMutations } from "vuex";
import api from "@/api/company";
import apiProduct from "@/api/product";

export default {
    components: {
        HeaderForm,
        SimpleTable,
        DialogDelete,
    },
    data: () => ({
        modelCompany: {
            id: "",
            name: "",
            email: "",
            appboxes: [],
            users: [],
            enabled: 1,
        },
        headers: [
            {
                text: 'Nome', value: 'product_name', align: 'start',
            },
            {
                text: "Ações",
                value: "actions",
                align: "end",
                sortable: false,
                width: 200,
            },
        ],
        company: {},
        productSelected: null,
        products: [],
        isLoading: true,
        isUpdating: true,
        dialogDelete: false,
        _productDelete: {},
        errorMessageCompanyAutocomplete: '',
    }),
    created() {
        this.company = { ...this.modelCompany };
        this.initialize();
    },
    methods: {
        ...mapMutations(["showLoading", "hideLoading", "showAlert"]),
        async initialize() {
            if (this.$route.params.id) {
                await this.getCompany(this.$route.params.id);
                await this.getProduct();
            } else {
                this.showAlert({ message: 'Acesso incorreto', type: "error" });
                this.$router.push(`/admin/empresas`)
            }
        },
        async getCompany(id) {
            try {
                this.showLoading();
                let response = await api.show(id);
                this.company = response.data;
            } catch (error) {
                this.company = { ...this.modelCompany };
                this.showAlert({ message: error.message, type: "error" });
            } finally {
                this.hideLoading();
            }
        },
        async getProduct() {
            this.isLoading = true;
            this.isUpdating = true;
            try {
                let { data } = await apiProduct.get();
                data = data.filter(item => item.enabled === 1).sort((a, b) => a.product_name.localeCompare(b.product_name));
                this.products = data;
            } catch (error) {
                this.products = [];
                this.showAlert({ message: error.message, type: "error" });
            } finally {
                this.isLoading = false;
                this.isUpdating = false;
            }
        },
        goToBackList() {
            this.$router.push(`/admin/empresas`);
        },
        async handleAddProduct() {
            if (this.productSelected === null) {
                this.errorMessageCompanyAutocomplete = 'Selecione um Produto para poder Adicionar';
                return;
            }
            this.showLoading();
            let productsSync = [...this.company.products.map(item => item.id)];
            productsSync.push(this.productSelected);
            try {
                let response = await api.postProducts(this.company.id, { products: productsSync });
                this.company.products = response;
                this.productSelected = null;
                this.showAlert({ message: 'Produto Vinculado com sucesso', type: "success" });
            } catch (error) {
                this.showAlert({ message: error.message, type: "error" });
            } finally {
                this.hideLoading();
            }
        },
        hideProductsExist(data) {
            if (this.company.products == null) {
                return;
            }
            let idsProducts = this.company.products.map(item => item.id);
            return data.filter(item => !idsProducts.includes(item.id));
        },
        deleteProduct(item) {
            this._productDelete = item;
            this.dialogDelete = true;
        },
        async handleConfirmDelete() {
            this.dialogDelete = false;
            let productsSync = [...this.company.products.map(item => item.id).filter(item => item !== this._productDelete.id)];
            this.showLoading();
            try {
                let response = await api.postProducts(this.company.id, { products: productsSync });
                this.company.products = response;
                this.productsSelected = null;
                this.showAlert({ message: 'Produto Desvinculado com sucesso', type: "success" });
            } catch (error) {
                this.showAlert({ message: error.message, type: "error" });
            } finally {
                this.hideLoading();
            }
        },
        handleCancelDelete() {
            this.dialogDelete = false;
            this._productDelete = {};
        }
    },
};
</script>
